export interface SalesDespatchItemDespatchNote {
  id: string;
  stockNo: string;
  orderNo: string;
  packNo: number;
  productKey: string;
  productDescription: string;
  invoicePrice: number;
  freeOfChargeQty: number;
  grossQuantity: number;
  nettQuantity: number;
  selected: boolean;
  canDelete: boolean;
  invoiced: boolean;
  salesOrderLineId: string;
}
